import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_PAY_CONFIG_DETAIL',
        create: 'MARKET_PAY_CONFIG_CREATE',
        update: 'MARKET_PAY_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var create_url = {
        prop: 'create_url',
        default: '',
        label: this.$t('create_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.create_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "create_url", $$v);
              }
            }
          });
        }
      };
      var return_url = {
        prop: 'return_url',
        default: '',
        label: this.$t('return_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.return_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "return_url", $$v);
              }
            }
          });
        }
      };
      var capture_url = {
        prop: 'capture_url',
        default: '',
        label: this.$t('capture_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.capture_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "capture_url", $$v);
              }
            }
          });
        }
      };
      var cancel_url = {
        prop: 'cancel_url',
        default: '',
        label: this.$t('cancel_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.cancel_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "cancel_url", $$v);
              }
            }
          });
        }
      };
      var brand_name = {
        prop: 'brand_name',
        default: '',
        label: this.$t('brand_name'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.brand_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "brand_name", $$v);
              }
            }
          });
        }
      };
      var local = {
        prop: 'local',
        default: '',
        label: this.$t('local'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.local,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "local", $$v);
              }
            }
          });
        }
      };
      var currency_code = {
        prop: 'currency_code',
        default: '',
        label: this.$t('currency_code'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.currency_code,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "currency_code", $$v);
              }
            }
          });
        }
      };
      var soft_descriptor = {
        prop: 'soft_descriptor',
        default: '',
        label: this.$t('soft_descriptor'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.soft_descriptor,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "soft_descriptor", $$v);
              }
            }
          });
        }
      };
      var appid = {
        prop: 'appid',
        default: '',
        label: this.$t('appid'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.appid,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "appid", $$v);
              }
            }
          });
        }
      };
      var mch_id = {
        prop: 'mch_id',
        default: '',
        label: this.$t('mch_id'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.mch_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "mch_id", $$v);
              }
            }
          });
        }
      };
      var trade_type = {
        prop: 'trade_type',
        default: '',
        label: this.$t('trade_type'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.trade_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "trade_type", $$v);
              }
            }
          });
        }
      };
      return [].concat(_toConsumableArray(this.mode === 'create' ? [{
        prop: 'app_id',
        default: '',
        label: this.$t('app_id'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_id", $$v);
              }
            }
          });
        }
      }] : []), [{
        prop: 'pay_type',
        default: '',
        label: this.$t('pay_type'),
        col: {
          span: 16
        },
        // render: () => <d2-dict-select name="pay_method" vModel={ this.form.model.pay_type } on-change={ this.onTypeChange } button/>
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_pay_method",
              "button": true
            },
            "on": {
              "change": _this.onTypeChange
            },
            "model": {
              value: _this.form.model.pay_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pay_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'is_default',
        default: '',
        label: this.$t('is_default'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "pay_config_is_default",
              "button": true
            },
            "model": {
              value: _this.form.model.is_default,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_default", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: '',
        label: this.$t('status'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "pay_config_status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }], _toConsumableArray(this.form.model.pay_type == 'Pay' ? [create_url, return_url, capture_url, cancel_url, brand_name, local, currency_code, soft_descriptor] : this.form.model.pay_type == 'PayPal' ? [create_url, return_url, capture_url, cancel_url, brand_name, local, currency_code, soft_descriptor] : this.form.model.pay_type == 'WeChat' ? [appid, mch_id, trade_type] : []));
    }
  },
  methods: {
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_pay_method',
        method: this.$api.PAY_TYPE_ALL,
        fields: 'pay_type,name',
        path: 'list',
        label: 'name',
        value: 'pay_type'
      });
    },
    onTypeChange: function onTypeChange() {
      this.modelReload({
        pick: ['app_id', 'pay_type', 'is_default', 'status', 'json_data']
      });
    }
  }
};